<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="lookup-form">
      <v-card class="mx-auto w-full lookup-form__card" flat max-height="auto" max-width="1000">
        <div class="lookup-form__grid flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              CPD Category
            </label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                  v-model="formValues.cpdCategoryId"
                  :clearable="clearable"
                  :items="CATEGORIES"
                  :loading="categoriesLoading"
                  item-text="name"
                  item-value="id"
              ></v-autocomplete>
              <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              Role
            </label>
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="role"
                  v-model="formValues.role"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              Multiplier
            </label>
            <validation-provider v-slot="{ errors }">
              <input
                  id="multiplier"
                  v-model="formValues.multiplier"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              CEU
            </label>
            <validation-provider v-slot="{ errors }" rules="required|min_value:0">
              <input
                  id="ceu"
                  v-model.number="formValues.ceu"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="number"
                  min="0"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="lookup-form__actions">
          <v-btn class="lookup-form__cancel" text type="button" @click="$emit('close')">
            Cancel
          </v-btn>
          <v-btn
              class="lookup-form__submit white--text"
              color="primary"
              depressed
              @click="submit()"
          >
            {{ formValues.editMode ? "Update" : "Add" }}
          </v-btn>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {min_value, required} from "vee-validate/dist/rules";
import {getCategories} from "@/utils/helper";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("min_value", {
  ...min_value,
  message: "Invalid value",
});

export default {
  props: {
    requirement: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        cpdCategoryId: null,
        role: "",
        multiplier: "",
        ceu: null,
        editMode: false,
      },
      CATEGORIES: [],
      categoriesLoading: false,
      clearable: true,
    };
  },
  async created() {
    if (this.requirement != null) {
      this.formValues = this.requirement;
      this.formValues.editMode = true;
    }

    this.categoriesLoading = true;
    this.CATEGORIES = await getCategories();
    this.categoriesLoading = false;
  },
  methods: {
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateRequirement", this.formValues);
    },
  },
};
</script>
